import { BlockedAccessScreen } from '@hero/web-components';
import { useCurrentUser } from '@hero/hooks-shared';
import { useLogoutManager, useNav } from '@hero/web-hooks';

export default function AccountBlockedPage() {
  const { user } = useCurrentUser();
  const { logout } = useLogoutManager();
  const { getParams } = useNav();
  const { phone: phoneFromQuery } = getParams('account_blocked');

  return (
    <BlockedAccessScreen
      kind="user"
      phone={phoneFromQuery ?? user?.phone}
      onSignOut={logout}
    />
  );
}
